<ng-container [ngSwitch]="control?.controlType">

    <div *ngSwitchCase="[60, 61, 63, 64] | switchMultiCase:control?.controlType">
        <!--CUSTOM BUTTON -->
        <cp-generic [control]="genericControl"
                    [cardId]="cardId"
                    [disabled]="disabled"
                    [onlyIcon]="true">
        </cp-generic>
    </div>

    <!--IMPORT-->
    <div *ngSwitchCase="55">
        <cp-import [control]="importControl"
                   [cardId]="cardId"
                   [disabled]="disabled"
                   [onlyIcon]="true">
        </cp-import>
    </div>

    <div *ngSwitchCase="91">
        <cp-grid-default-groups [control]="importControl"
                                [cardId]="cardId"
                                [disabled]="disabled"
                                [onlyIcon]="true"
                                (edited)="_onEdited()">
        </cp-grid-default-groups>
    </div>

</ng-container>
